export default "__VITE_ASSET__AnZ0wLiY__"